export enum HrEmployeeModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
